var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('access-table',{attrs:{"data-u-r-l":"/api/management/v1/access"}})}
var staticRenderFns = []

export { render, staticRenderFns }